export enum LANGUAGES {
  default = 'en',
  it = 'it',
  en = 'en',
  de = 'de',
  fr = 'fr',
  es = 'es',
  pt = 'pt',
}
